module.exports = __webpack_public_path__ + "img/business-settlement-icon.fca43e4f.svg";